
import { Vue, Component, Prop } from "vue-property-decorator";

import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
import PricePlanProvider from "@/components/payment/prices/PricePlanProvider.vue";
import PriceCardViewTitle from "@/components/payment/prices/PriceCardViewTitle.vue";
import PriceCardViewPricing from "@/components/payment/prices/PriceCardViewPricing.vue";
import UiButton from "@/components/button/ui-button.vue";

import { SubscriptionPlan } from "@/entities/payment/SubscriptionPlan";

@Component({
    components: {
        ModalFullScreen,
        ModalSectionsDivider,
        PricePlanProvider,
        PriceCardViewTitle,
        PriceCardViewPricing,
        UiButton,
    },
})
export default class SubscriptionActionModalForManagerAddon extends Vue {
    @Prop({ type: Object, required: true }) readonly subscription!: SubscriptionPlan;
    @Prop({ type: String, required: true }) readonly managersPrice!: string;
    @Prop({ type: String, required: true }) readonly selectedSubscriptionPlanId!: string;
    @Prop({ type: String, required: true }) readonly getSelectedNumberOfManagers!: string;


    processing: boolean = false;

    get innerSubscriptionName(): string {
        return this.subscription.inner_name;
    }

    get managersCount(): number | undefined {
        return this.subscription.subscription_plan_access_permission?.managers_count;
    }
}
